module.exports = __webpack_public_path__ + "img/Notibell2.42a2c029.svg";